import { createAction } from "@reduxjs/toolkit";

export const updateUserTypeData = createAction("UPDATE_USER_TYPE_DATA");
export const resetUserTypeData = createAction("RESET_USER_TYPE_DATA");
